export enum IPaymentStatus {
  CREATED = 'Created',
  PROCESSING = 'Processing',
  FAILED = 'Failed',
  SUCCEEDED = 'Succeeded',
  NO_PAYMENTS = 'No_Payments',
  PAY_AFTER = 'Pay_After',
  REFUNDED = 'Refunded'
}